import React from 'react';
import { ArrowLeft } from 'lucide-react';
import '../styles/PortalPage.css';

/**
 * The page frame every portal page uses.
 *
 * Pages each built their own header, so the title landed in a different place
 * on every one — measured at x=421, x=461 and x=571 across three pages, in two
 * sizes, with four pages carrying no title at all. Position and rhythm are not
 * a per-page decision; they belong to the frame.
 *
 * `back` — { label, onClick } or { label, href }. Rendered above the title, in
 * one place, so returning is the same gesture on every screen.
 *
 * `width`:
 *   'default' — most pages
 *   'narrow'  — reading pages (prose, instructions)
 *   'full'    — control surfaces that should not be capped (editors, tables)
 */
function PortalPage({ title, lede, actions, back, width = 'default', className = '', children }) {
  const widthClass = width === 'default' ? '' : ` portal-page--${width}`;
  return (
    <div className={`portal-page${widthClass}${className ? ' ' + className : ''}`}>
      {back && (
        <button className="portal-back" onClick={back.onClick} type="button">
          <ArrowLeft size={14} />
          <span>{back.label}</span>
        </button>
      )}
      {(title || actions) && (
        <header className="portal-page__head">
          <div className="portal-page__heading">
            {title && <h1>{title}</h1>}
            {lede && <p className="portal-page__lede">{lede}</p>}
          </div>
          {actions && <div className="portal-page__actions">{actions}</div>}
        </header>
      )}
      {children}
    </div>
  );
}

export default PortalPage;
